@if (inModal) {
  <div class="modal-header">
    <h5 class="modal-title" [innerText]="'ENQUIRY_FLIGHT_EDIT.ADD_LEG' | translate"></h5>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      [attr.aria-label]="'GENERAL.CLOSE' | translate"
      #btnCloseModal
    ></button>
  </div>
}
<div [class.modal-body]="inModal" class="text-center">
  {{ 'ENQUIRY_FLIGHT_EDIT.ADD.HOW_TO_ADD_NEW_LEG' | translate }}

  <div class="form-check justify-content-center">
    <input
      class="form-check-input"
      type="radio"
      name="add-type"
      id="add-type-scratch"
      [(ngModel)]="addType"
      [value]="EnumAddType.scratch"
      />
    <label class="form-check-label" for="add-type-scratch" [innerText]="'ENQUIRY_FLIGHT_EDIT.ADD.START_FROM_SCRATCH' | translate"></label>
  </div>
  <div class="form-check justify-content-center">
    <input
      class="form-check-input"
      type="radio"
      name="add-type"
      id="add-type-duplicate"
      [(ngModel)]="addType"
      [value]="EnumAddType.duplicate"
      />
    <label class="form-check-label" for="add-type-duplicate" [innerText]="'ENQUIRY_FLIGHT_EDIT.ADD.DUPLICATE_FROM_EXISTING_LEG' | translate"></label>
  </div>

  @if (addType === EnumAddType.duplicate) {
    <div class="form-group mb-0">
      <select class="form-select" id="legId" [(ngModel)]="enquiryFlightId">
        <option [ngValue]="null" [innerText]="'GENERAL.PLEASE_SELECT_ONE' | translate"></option>
        @for (enquiryFlight of enquiryFlights; track enquiryFlight.id) {
          <option
            [value]="enquiryFlight.id"
                [innerText]="
                    (enquiryFlight.departDateTimeLocal | date : 'dd/MM/yyyy HH:mm') +
                    ' : ' +
                    enquiryFlight.airportDepartIataCode +
                    ' → ' +
                    enquiryFlight.airportArrivalIataCode
                "
          ></option>
        }
      </select>
    </div>
  }
</div>

<div [class.modal-footer]="inModal" class="justify-content-center">
  <button
    type="button"
    class="btn btn-primary"
    (click)="save()"
    [disabled]="!addType || (addType === EnumAddType.duplicate && !enquiryFlightId)"
    [innerText]="'GENERAL.SAVE' | translate"
  ></button>
</div>
